var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mybody2",attrs:{"id":"mymapBox"}},[_c('iframe',{staticStyle:{"width":"500px","height":"500px"},attrs:{"src":"http://storage.xuetangx.com/public_assets/xuetangx/PDF/PlayerAPI_v1.0.6.pdf","frameborder":"0"}})])
}]

export { render, staticRenderFns }